import React, { Component } from 'react';
import Analytics from 'react-ga';
import Navbar from '../Navbar';
import ContentSection from '../ContentSection';
import LessonsMessageModal from '../LessonsMessageModal';
import LessonTeachersSection from '../LessonTeachersSection';
import Quote from '../Quote';
import acousticGuitarImage from './assets/acoustic-guitar.png';
import electricGuitarImage from './assets/electric-guitar.png';
import bassImage from './assets/bass-guitar.png';
import drumsImage from './assets/drums.png';
import recordingImage from './assets/recording.png';
import ukeleleImage from './assets/ukelele.png';
import mandolinImage from './assets/mandolin.png';
import banjoImage from './assets/banjo.png';
import './styles.css';

export default class LessonsPage extends Component {

  constructor(props) {
    super(props);
    this.state = { showMessageModal: false };
  }

  componentDidMount() {

    Analytics.pageview('/lessons');
  }

  render() {
    return (
      <Navbar location={this.props.location}>
        {this.state.showMessageModal && <LessonsMessageModal onDismiss={this._handleModalDismiss}/>}
        <div className="lessons-page">
          <LessonTeachersSection onMessageLinkClick={this._handleMessageClick} />
          <ContentSection className="lessons-description">
            <h1>Music education is our mission</h1>
            <p>
              When McGuire Music first opened in the spring of 1971, there
              was a big, wooden sign hanging above the entrance that read:
            </p>
            <Quote>McGuire Music - Where Teaching Is Our First Concern!</Quote>
            <p>
              The wooden sign is long gone, but our philosophy remains the same.
              Since 1971, thousands of people have come to McGuire Music to learn to play and enjoy their musical
              instruments.  If you are thinking about private lessons for yourself or
              someone in your family, think of McGuire Music!
            </p>
            <div>
              To request more info or schedule lessons, {/*<a onClick={this._handleMessageClick}>click here</a>*/} please call us at <a href="tel:765-474-2942">(765)474-2942</a>.
            </div>
          </ContentSection>
          <ContentSection className="instrument-icons-section" containerClassName="theme-background">
            <div className="instrument-icons">
              <div className="instrument-icon">
                <img src={acousticGuitarImage} alt="acoustic guitar" title="We teach acoustic guitar"/>
              </div>
              <div className="instrument-icon">
                <img src={electricGuitarImage} alt="electric guitar" title="We teach electric guitar"/>
              </div>
              <div className="instrument-icon">
                <img src={bassImage} alt="bass guitar" title="We teach bass guitar"/>
              </div>
              <div className="instrument-icon">
                <img src={drumsImage} alt="drums" title="We teach drums"/>
              </div>
            </div>
            <div className="instrument-icons">
              <div className="instrument-icon">
                <img src={recordingImage} alt="audio recording" title="We teach audio recording"/>
              </div>
              <div className="instrument-icon">
                <img src={ukeleleImage} alt="ukelele" title="We teach ukelele"/>
              </div>
              <div className="instrument-icon">
                <img src={mandolinImage} alt="mandolin" title="We teach mandolin"/>
              </div>
              <div className="instrument-icon">
                <img src={banjoImage} alt="banjo" title="We teach banjo"/>
              </div>
            </div>
          </ContentSection>
        </div>
      </Navbar>
    );
  }

  _handleMessageClick = () => this.setState({ showMessageModal: true });

  _handleModalDismiss = () => this.setState({ showMessageModal: false });
}



// WEBPACK FOOTER //
// ./src/components/LessonsPage/index.js